// extracted by mini-css-extract-plugin
export default {"processItemName":"processItemName-yvbQf","main":"main-CzetV","subtext":"subtext-rhegf"};